import { useState } from "react";
import { Modal } from "react-bootstrap";
import ToggleSwitch from "./Util/ToggleSwitch";

const ManageOrgModal = (props) => {
    const getDefaultOrg = (orgToEdit) => {
        const defaultSettings = {
            hideAnnotations: false,
            hideTimelineViews: false,
            hideDashboard: false,
            showAoiLines: false
        };
    
        const orgFromProps = orgToEdit ?? {
            name: '',
            description: '',
            settings: defaultSettings
        };
    
        return {
            ...orgFromProps,
            settings: {
                ...defaultSettings,
                ...orgFromProps.settings
            }
        };
    };

    const [org, setOrg] = useState(getDefaultOrg(props.orgToEdit));

    const saveOrgDetails = () => {
        props.saveOrgDetails(org);
    };

    return (
        <Modal
            show={() => props.setShowManageOrgModal(true)}
            onHide={() => props.setShowManageOrgModal(false)}
            backdrop="static"
            keyboard={false}
            size='md'
            dialogClassName="manage-org-modal-dialog"
            className="manage-org-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>{`${props.orgToEdit ? 'Edit' : 'Create'} Organization`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="manage-org-form-body">
                    <div className="form-group">
                        <label className="form-label" htmlFor="manage-org-name">Organization Name</label>
                        <input type="text" className="form-control" value={org.name} onInput={e => setOrg({ ...org, name: e.target.value })}/>
                    </div>
                    
                    <div className="form-group">
                        <label className="form-label" htmlFor="manage-org-name">Description</label>
                        <input type="text" className="form-control" value={org.description} onInput={e => setOrg({ ...org, description: e.target.value })}/>
                    </div>

                    <div className="form-group">
                        <ToggleSwitch checked={!org.settings?.hideAnnotations} onChange={(e) => setOrg({...org, settings: {...org.settings, hideAnnotations: !org.settings.hideAnnotations}})} label={"Annotations"} />
                    </div>
                    <div className="form-group">
                        <ToggleSwitch checked={!org.settings?.hideTimelineViews} onChange={(e) => setOrg({...org, settings: {...org.settings, hideTimelineViews: !org.settings.hideTimelineViews}})} label={"Timeline Views"} />
                    </div>
                    <div className="form-group">
                        <ToggleSwitch checked={!org.settings?.hideDashboard} onChange={(e) => setOrg({...org, settings: {...org.settings, hideDashboard: !org.settings.hideDashboard}})} label={"Dashboard"} />
                    </div>
                    <div className="form-group">
                        <ToggleSwitch checked={org.settings?.showAoiLines} onChange={(e) => setOrg({...org, settings: {...org.settings, showAoiLines: !org.settings.showAoiLines}})} label={"AOI Lines"} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="btn-area">
                    <a onClick={() => props.setShowManageOrgModal(false)} className="btn btn-text">Cancel</a>
                    <button type="button" className="btn btn-primary" aria-label="Submit" onClick={saveOrgDetails}>
                        {`${props.orgToEdit ? 'Save' : 'Create'}`}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    ); 
}

export default ManageOrgModal;